const $inject = ['$filter', 'moment', 'settingsService'];

const breakPolicyService = function breakPolicyService($filter, moment, settingsService) {
  let service = {
    getLeadInTimeMessage: getLeadInTimeMessage,
    getFlightLostSavingsMessage: getFlightLostSavingsMessage,
    getHotelLostSavingsMessage: getHotelLostSavingsMessage,
    getCarLostSavingsMessage: getCarLostSavingsMessage,
  };

  function getLeadInTimeMessage(policyExceptionDetails) {
    const p = policyExceptionDetails;

    return `
      Your company requires bookings to be made at least ${minsToDisplayLabel(p.CompanyPolicyLeadInTimeInMinutes, false)} in advance. 
      This selection is ${minsToDisplayLabel(p.SelectionLeadInTimeInMinutes, true)} in advance.
    `;
  }

  function minsToDisplayLabel(mins, isSelectionDisplay) {
    const minsInhour = 60;
    const hours = Math.floor(mins / minsInhour);

    if(hours === 0) {
      return (isSelectionDisplay ? 'less than an hour' : 'an hour');
    }
    else if(hours < 73) {
      return (isSelectionDisplay ? `only ${pluralize('hour', hours)}` : `${pluralize('hour', hours)}`);
    } else {
      const days = Math.floor(hours / 24);
      var remainingHours = Math.round(hours % 24);
      remainingHours = (remainingHours > 0 ? `, ${pluralize('hour', remainingHours)}` : '');
  	  return (isSelectionDisplay ? `only ${pluralize('day', days)}` + remainingHours : `${pluralize('day', days)}` + remainingHours);
    }
  }

  function pluralize(word, amount) {
    return amount.toString() + ' ' + word + (amount === 1 ? '' : 's');
  }

  function getFlightLostSavingsMessage(policyExceptionDetails) {
    const p = policyExceptionDetails;
    const currencyCode = settingsService.currencyCode();
    const timeFormat = $filter('translate')('dates.TimeFormatLong');
    const priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
    const minimumTimeOfCheapestOption = moment(p.MinimumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
    const maximumTimeOfCheapestOption = moment(p.MaximumTimeOfCheapestOption, 'HH:mm').format(timeFormat);

    let message = '';

    if(p.MultipleCheapestOptions) {
      const flightText = p.IsCombinableFare ? 'combinable flights' : 'flights';

      if(p.MinimumTimeOfCheapestOption === p.MaximumTimeOfCheapestOption) {
        message = `There were multiple cheaper ${flightText} departing at ${minimumTimeOfCheapestOption} for ${priceCheapestOption}${currencyCode}`;
      } else {
        message = `There were multiple cheaper ${flightText} departing between ${minimumTimeOfCheapestOption} and ${maximumTimeOfCheapestOption}, at ${priceCheapestOption}${currencyCode}`;
      }
    } else {
      if(p.IsCombinableFare) {
        message = `Flight ${p.NameOfCheapestOption} departs at ${maximumTimeOfCheapestOption} and has a cheaper combinable option at ${priceCheapestOption}${currencyCode}`;
      } else {
        message = `Flight ${p.NameOfCheapestOption} departs at ${maximumTimeOfCheapestOption} and is cheaper at ${priceCheapestOption}${currencyCode}`;
      }
    }

    return message;
  }

  function getHotelLostSavingsMessage(policyExceptionDetails) {
    const p = policyExceptionDetails;
    const currencyCode = settingsService.currencyCode();
    const priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);

    return `${p.NameOfCheapestOption} has a cheaper room at ${priceCheapestOption}${currencyCode}`;
  }

  function getCarLostSavingsMessage(policyExceptionDetails) {
    const p = policyExceptionDetails;
    const currencyCode = settingsService.currencyCode();
    const priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);

    return `${p.NameOfCheapestOption} is a cheaper car at ${priceCheapestOption}${currencyCode}`;
  }

  return service;
};


breakPolicyService.$inject = $inject;

export default breakPolicyService;




// WEBPACK FOOTER //
// ./src/services/breakPolicyService.js